import { AttributeInfoResolver } from '@intercom/interblocks.ts';
export { AttributeInfoResolver };
export const INLINE_CONTROL_BLOCK_TYPES = 'inline_control_block_types';
export const INLINE_CONTROL_ALIGNMENT = 'inline_control_alignments';
// Re-export SkinToneModifiers from composer-core
import { SkinToneModifiers as CoreSkinToneModifiers } from '@intercom/composer-core';
export const SkinToneModifiers = CoreSkinToneModifiers;